import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setMapPosition, setPositionsOfGeoMarkers, showToastMessage } from '../../../../../stateManagement/reducers'
import { useLazyFetchPathPositionCoordsQuery } from '../../../../../api/rtk/base/slices/mapApiSlice'
import { useAppSelector } from '../../../../../stateManagement/hooks/redux'

const clearInputButtonIconSrc = require('../../../../../assets/images/fontAwesomeIcons/xmark-solid-dark.svg').default

export default function MapPathPositionSearch() {
    const dispatch = useDispatch()
    const [inputPathPositionValue, setInputPathPositionValue] = useState<any>('')
    const [pathPositionValue, setPathPositionValue] = useState<any>('')
    const [fetchPathPositionCoords, { isError: isErrorPathPositionCoords, isFetching: isFetchingPathPositionCoords }] = useLazyFetchPathPositionCoordsQuery()
    const { mapPathValue, mapPathPosition, mapPathEnding } = useAppSelector(state => state.maps.path)
    const showClearInputButton = !!pathPositionValue

    // Переход к км+ на дороге

    useEffect(() => {
        if (pathPositionValue) {
            (async () => {
                try {
                    await moveMapToPositionOnPath(); // бросает наружу
                } catch (error: any) {
                    dispatch(showToastMessage({ messageText: error.message, messageType: "error", windowType: "map" }))
                }
            })();
        }
    }, [pathPositionValue]);

    async function moveMapToPositionOnPath() {
        const { pathId, roadId }: any = mapPathValue
        let response;
        try {
            const { data: maintenancePositionResponse }: any = await fetchPathPositionCoords({ roadId, pathId, position: pathPositionValue })
            if (Object.hasOwn(maintenancePositionResponse, 'Error') && maintenancePositionResponse.Error === "Invalid maintenance position") {
                throw new Error("Эксплуатационный километр не найден. Производится поиск по проектному километру.")
            }
            response = maintenancePositionResponse;
        } catch (error: any) {
            dispatch(showToastMessage({ messageText: error.message, messageType: "error", windowType: "map" }))
            const projectPathPosition = pathPositionValue.replace('+', '.');
            const { data: projectPositionResponse }: any = await fetchPathPositionCoords({ roadId, pathId, position: projectPathPosition })
            if (Object.hasOwn(projectPositionResponse, 'Error')) {
                let messageText = ''
                if (mapPathPosition && mapPathEnding) {
                    messageText = `Выбранная дорогая не проходит через указанное положение. Выберите положение в приблизительном промежутке  от ${mapPathPosition} до ${mapPathEnding}.`
                } else {
                    messageText = 'Выбранная дорогая не проходит через указанное положение.'
                }
                throw new Error(messageText)
            }
            response = projectPositionResponse;
        }
        const { Latitude, Longitude } = response ?? {}
        const mapPosition = { latitude: Latitude, longitude: Longitude, zoom: 11 }
        dispatch(setMapPosition(mapPosition))
        dispatch(setPositionsOfGeoMarkers([mapPosition]))
    }

    // Проверка формата значения км+ на дороге

    function checkFormatPathPositionValue(pathPositionValue: any) {
        const regExpOfKmPlus = /^\d+\+\d{0,3}$/
        const regExpOfKmMinus = /^\d+\-\d{0,3}$/
        const regExpOfKm = /^\d+$/
        let formattedPathPositionValue = ''
        if (regExpOfKmPlus.test(pathPositionValue)) {
            const [km, m]: [string, string] = pathPositionValue.split('+')
            formattedPathPositionValue = `${km}+${m.padStart(3, '0')}`
            setInputPathPositionValue(formattedPathPositionValue)
            setPathPositionValue(formattedPathPositionValue)
        } else if (regExpOfKmMinus.test(pathPositionValue)) {
            const [km, m]: [string, string] = pathPositionValue.split('-')
            formattedPathPositionValue = `${km}-${m.padStart(3, '0')}`
            setInputPathPositionValue(formattedPathPositionValue)
            setPathPositionValue(formattedPathPositionValue)
        } else if (regExpOfKm.test(pathPositionValue)) {
            formattedPathPositionValue = `${pathPositionValue}+000`
            setInputPathPositionValue(formattedPathPositionValue)
            setPathPositionValue(formattedPathPositionValue)
        } else {
            dispatch(showToastMessage({ messageText: 'Значение Км+ должно соответствовать формату км+м', messageType: "error", windowType: "map" }))
        }
    }

    function handleEnterPressOnPathPositionValueInput(event: any) {
        const keyCode = event.keyCode
        if (keyCode === 13) {
            checkFormatPathPositionValue(inputPathPositionValue)
        }
    }

    function clearPathPositionInput() {
        setInputPathPositionValue('')
        setPathPositionValue('')
        dispatch(setPositionsOfGeoMarkers([]))
    }

    return (
        <div className='map-path-position-search-div'>
            {showClearInputButton &&
                <button className='clear-input-button' onClick={clearPathPositionInput}>
                    <img src={clearInputButtonIconSrc} />
                </button>
            }
            <input
                id="map-path-position-input"
                className={showClearInputButton ? 'with-clear-button' : ''}
                value={inputPathPositionValue}
                onChange={(e: any) => setInputPathPositionValue(e.target.value)}
                onKeyDown={handleEnterPressOnPathPositionValueInput}
                autoComplete="off"
                placeholder="Км+"
            />
        </div>
    )
}
